import React, { useCallback } from 'react';
import { useBiLogger } from '../../../../../../biLogger/hooks/useBiLogger';
import { BiEventType } from '../../../../../../biLogger/constants';
import { getDeviationResourceType } from '../../../../../_helpers';
import PopperDropdownManager from '../../../../../../Dropdown2/PopperDropdownLayout/PopperDropdownManager';
import PopperDropdownToggle from '../../../../../../Dropdown2/PopperDropdownLayout/PopperDropdownToggle';
import PopperDropdownContent from '../../../../../../Dropdown2/PopperDropdownLayout/PopperDropdownContent';
import StandardMenu from '../../../../../../Dropdown2/MenuPreset/StandardMenu';
import { ThemeOverride } from '../../../../../../Context/ThemeContext';
import ButtonB5 from '../../../../../../Button/ButtonB5';
import { IconSize } from '../../../../../../Icons/IconWrap';
import { ThemeOptions } from '../../../../../../publicSession/types';
import EllipsisIcon from '../../../../../../Icons/Ellipsis';
import s from './ThumbActions.scss';
var ThumbActions = function (_a) {
    var deviation = _a.deviation, actions = _a.actions, className = _a.className;
    var logger = useBiLogger();
    var typeid = getDeviationResourceType(deviation);
    var onOpen = useCallback(function () {
        logger({
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: typeid,
            itemid: deviation.deviationId,
        });
    }, [logger, typeid, deviation.deviationId]);
    return (React.createElement(PopperDropdownManager, { onOpen: onOpen },
        React.createElement(PopperDropdownToggle, { className: className },
            React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
                React.createElement(ButtonB5, { icon: EllipsisIcon, className: s['toggle'], iconProps: {
                        size: IconSize.SMALL,
                    } }))),
        React.createElement(PopperDropdownContent, { usePortal: true },
            React.createElement(StandardMenu, { items: actions, className: s['menu'] }))));
};
ThumbActions.displayName = 'ThumbActions';
export default ThumbActions;
//# sourceMappingURL=ThumbActions.js.map